import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { take } from 'rxjs/operators';
import { LanguageService } from './core/services/language/language.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(public oidcSecurityService: OidcSecurityService, public router: Router, private languageService: LanguageService) {}

  ngOnInit(): void {
    this.oidcSecurityService
      .checkAuthMultiple(window.location.href)
      .pipe(take(1))
      .subscribe((results) => {
        const authenticated = results?.find((r) => r.isAuthenticated);
        if (authenticated) {
          const currentUrl = this.router.url;
          const isOidcCallback = currentUrl.includes('?code=') || currentUrl.includes('&code=');
          if (isOidcCallback || currentUrl.startsWith('/login')) {
            this.router.navigateByUrl('/home', { replaceUrl: true });
          }
        }
      });
  }
}
